import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import toaster from "toasted-notes";

import "toasted-notes/src/styles.css";
import { TotalChargeWrapper } from "../catalogue.styles";
import { NormalText, SemiBoldText, SmallHeaderText } from "../../../../../common/common.styles";
import Button, { LightButton } from "../../../../../../../library/otherButton/Button";
import { formatKoboBalance } from "../../../../../../../utils/utilityFunctions";
import { ActionTypes, ChargeItemsContext } from "../../../context";
import { updateSalesOrder } from "../../../../../../../redux/actions/salesOrder.acton";
import SaveModal from "../../../common/modals/SaveModal";
import { Portal } from "../../../../../../AuthenticatedApp/components/modals/Portal";
import SuccessModal from "../../../../../../AuthenticatedApp/components/modals/SuccessModal";
import { SuccessMessageStyled } from "../../../../../../AuthenticatedApp/components/productCatalogue/common/common.styles";
import ConfirmationModal from "../../../../../../AuthenticatedApp/components/productCatalogue/common/modals/ConfirmationModal";

const initialModalState = {
    saveModal: false,
    successModal: false,
    warningnModal: false,
};

const TotalSummaryCharge = ({ totalPrice }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [saveSubmitting, setSaveSubmitting] = useState(false);
    const [showModals, setShowModals] = useState(initialModalState);

    const [orderNameValue, setOrderNameValue] = useState("");

    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const { state, contextDispatch } = useContext(ChargeItemsContext);

    const openModal = (name) => {
        setShowModals((prev) => ({
            ...prev,
            [name]: true,
        }));
    };

    const closeModal = (name) => {
        setShowModals((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleUpdateOrder = async () => {
        setIsSubmitting(true);
        const groupCustomerId = Cookies.get("groupCustomerId");
        const payload = {
            id: state.orderId,
            ownerID: groupCustomerId,
            items: state.itemsState.map((item) => ({
                id: item.id,
                quantity: item.number,
            })),
        };

        try {
            const { status, message } = await dispatch(updateSalesOrder(payload));
            setIsSubmitting(false);

            if (status) {
                history.push("/sales/catalogue/checkout");
            } else {
                toaster.notify(message || "Sorry, an error occurred, Kindly try again.", {
                    duration: 5000,
                    position: "bottom",
                });
            }
        } catch (error) {
            setIsSubmitting(false);
        }
    };

    const handleSaveOrder = async () => {
        setSaveSubmitting(true);
        const groupCustomerId = Cookies.get("groupCustomerId");

        const payload = {
            id: state.orderId,
            ownerID: groupCustomerId,
            name: orderNameValue,
            items: state.itemsState.map((item) => ({
                id: item.id,
                quantity: item.number,
            })),
            status: 2,
        };
        try {
            const { status, message, statusCode } = await dispatch(updateSalesOrder(payload));
            setSaveSubmitting(false);

            if (status) {
                closeModal("saveModal");
                openModal("successModal");
                contextDispatch({
                    type: ActionTypes.RESET_ORDER,
                });
                setOrderNameValue("");
            } else if (statusCode === "k26") {
                closeModal("saveModal");
                openModal("warningnModal");
            } else {
                toaster.notify(message || "Sorry, an error occurred, Kindly try again.", {
                    duration: 5000,
                    position: "bottom",
                });
            }
        } catch (error) {
            setIsSubmitting(false);
        }
    };

    const handleContinueClick = () => {
        closeModal("warningnModal");
        openModal("saveModal");
    };

    useEffect(() => {
        if (location?.state?.orderName) {
            setOrderNameValue(location.state.orderName);
        }
    }, [location]);

    return (
        <Fragment>
            <TotalChargeWrapper>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Sub Total:</NormalText>
                    <NormalText className={state?.itemsState?.length < 1 && "sales__total-amout"}>
                        {formatKoboBalance(totalPrice)}
                    </NormalText>
                </div>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Tax 1:</NormalText>
                    <NormalText className={state?.itemsState?.length < 1 && "sales__total-amout"}>
                        ₦0.00
                    </NormalText>
                </div>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Tax 2:</NormalText>
                    <NormalText className={state?.itemsState?.length < 1 && "sales__total-amout"}>
                        ₦0.00
                    </NormalText>
                </div>
                <div className="sales__sub-total-item-wrap sales__total-item-wrap">
                    <SemiBoldText>Total:</SemiBoldText>
                    <SmallHeaderText className="sales__sum-total-amount">
                        {formatKoboBalance(totalPrice)}
                    </SmallHeaderText>
                </div>
                <div className="sales__pay-buttons-wrap">
                    <LightButton
                        text="Save"
                        width="170px"
                        onButtonClick={() => openModal("saveModal")}
                        disabled={state.orderNumber === ""}
                    />
                    <Button
                        text="Charge"
                        width="170px"
                        onButtonClick={handleUpdateOrder}
                        isSubmitting={isSubmitting}
                        disabled={state.itemsState?.length < 1 || state.orderNumber === ""}
                    />
                </div>
            </TotalChargeWrapper>
            {showModals.saveModal && (
                <Portal>
                    <SaveModal
                        closeModal={() => closeModal("saveModal")}
                        {...{
                            orderNameValue,
                            setOrderNameValue,
                            handleSaveOrder,
                            isSubmitting: saveSubmitting,
                        }}
                    />
                </Portal>
            )}
            {showModals.successModal && (
                <Portal>
                    <SuccessModal message="Okay" onClose={() => closeModal("successModal")}>
                        <SuccessMessageStyled>
                            Order has been saved. Kindly go to Order History to checkout when you’re
                            ready.
                        </SuccessMessageStyled>
                    </SuccessModal>
                </Portal>
            )}
            {showModals.warningnModal && (
                <Portal>
                    <ConfirmationModal
                        closeModal={() => closeModal("warningnModal")}
                        title="Order Name Already Exists"
                        details="This name is already saved for another order. Would you like to choose a different name?"
                        handleContinueClick={handleContinueClick}
                    />
                </Portal>
            )}
        </Fragment>
    );
};

export default TotalSummaryCharge;
